import {Coach} from "./Coach";
import a1_1 from '../../assets/rent/a1-1.jpeg';
import a1_2 from '../../assets/rent/a1-2.jpeg';
import a1_3 from '../../assets/rent/a1-3.jpeg';
import a1_4 from '../../assets/rent/a1-4.jpeg';
import a1_5 from '../../assets/rent/a1-5.jpeg';
import a1_6 from '../../assets/rent/a1-6.jpeg';

import a2_1 from '../../assets/rent/a2-1.jpeg';
import a2_2 from '../../assets/rent/a2-2.jpeg';
import a2_3 from '../../assets/rent/a2-3.jpeg';
import a2_4 from '../../assets/rent/a2-4.jpeg';
import a2_5 from '../../assets/rent/a2-5.jpeg';
import a2_6 from '../../assets/rent/a2-6.jpeg';

import a3_1 from '../../assets/rent/a3-1.jpg';
import a3_2 from '../../assets/rent/a3-2.jpg';
import a3_3 from '../../assets/rent/a3-3.jpeg';
import a3_4 from '../../assets/rent/a3-4.jpeg';
import a3_5 from '../../assets/rent/a3-5.jpeg';
import a3_6 from '../../assets/rent/a3-6.jpeg';

const coaches: Array<Coach> = [
    {
        name: 'Mercedes-Benz Tourismo O 350',
        passengerSeats: 49,
        facilities: [
            'Scaun pentru ghid',
            'Microfon',
            'Sistem audio-video',
            'Sistem de climatizare',
            'Toaletă'
        ],
        imagesUrls: [a1_1, a1_2, a1_3, a1_4, a1_5, a1_6]
    },
    {
        name: 'Mercedes-Benz Tourismo O 350',
        passengerSeats: 51,
        facilities: [
            'Scaun pentru ghid',
            'Microfon',
            'Sistem audio-video',
            'Sistem de climatizare',
            'Toaletă'
        ],
        imagesUrls: [a2_1, a2_2, a2_3, a2_4, a2_5, a2_6]
    },
    {
        name: 'Mercedes-Benz Tourismo O 350',
        passengerSeats: 53,
        facilities: [
            'Scaun pentru ghid',
            'Microfon',
            'Sistem audio-video',
            'Sistem de climatizare'
        ],
        imagesUrls: [a3_1, a3_2, a3_3, a3_4, a3_5, a3_6]
    }
]

export default coaches;